// Default (empty) Sales Area form record.
export const EMPTY_SA_FORM = {
  sales_org_id: '',
  dist_channel_id: '',
  division_id: '',
  sales_district_id: '',
  customer_group_id: '',
  sales_office_id: '',
  sales_group_id: '',
  currency_code: '',
  customer_pricing_procedure: '',
  delivery_priority_id: '',
  shipping_conditions_id: '',
  delivering_plant_id: '',
  incoterms_id: '',
  incoterms_location: '',
  terms_of_payment_sd: '',
  account_assignment_group: '',
  credit_control_area: '',
  order_combination: false,
  pod_relevant: false,
  rebate: false,
  max_partial_deliveries: '',
};
